<div class="lower-tutorial-container">
  <div>
    <div class="close-container">
      <div class="tutorial-close-button">
        <button class="navbar-toggler" type="button" aria-label="Close guide">
          <span id="guide-close" class="nav-link" (click)="close()"><img id="close-image" src="assets/images/close-static.svg" tabindex="0" /></span>
        </button>
      </div>
    </div>
    <div class="guide-container">
      <div class="tutorial-content">
        <router-outlet></router-outlet>
      </div>
      <div class="guide-nav-container">
        <div class="tutorial-progress-tracker">
          <mbc-step-progress-tracker>
            <ng-container *ngFor="let item of items | async">
              <mbc-single-step height="16" width="16" [active]="item.active"></mbc-single-step>
            </ng-container>
          </mbc-step-progress-tracker>
        </div>
        <div class="guide-nav-button-container">
          <button class="guide-nav-button btn-primary" (click)="continue()">{{ nextButtonText }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
